<template lang="pug">
.detail(:style="width")
  .detail__inner
    TransitionFade
      .detail__content(v-html="detail", :key="detail")
  
</template>

<script>
import TransitionFade from "../transitions/Fade.vue";
import { mapGetters } from "vuex";
export default {
  name: "AppDetail",
  props: ["detail"],
  components: {
    TransitionFade,
  },
  computed: {
    ...mapGetters(["width"]),
  },
};
</script>

<style lang="scss" scoped>
.detail {
  @include cell;
  position: relative;

  &__inner {
    z-index: 2;
  }

  &__content {
    word-break: break-word;
  }
}
</style>
